import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectCredentials, ProjectPermission } from './ProjectCredentials';

export interface ProjectCredentialsListProps {
  projects: ProjectCredentials[];
}

export class ProjectCredentialsList extends ValueObject<ProjectCredentialsListProps> {
  private constructor(props: ProjectCredentialsListProps) {
    super(props);
  }

  static create(props: ProjectCredentialsListProps) {
    return new ProjectCredentialsList(props);
  }

  test(projectId: string, ...permissions: ProjectPermission[]): boolean {
    const project = this.props.projects.find((project) => projectId === project.id);
    if (!project) return false;
    return permissions.every((permission) => project.test(permission));
  }

  get projects(): ProjectCredentials[] {
    return this.props.projects;
  }
  get permissions(): ProjectPermission[] {
    return this.props.projects.flatMap((project) => project.props.permissions);
  }
}
